module.exports = __webpack_public_path__ + "static/media/fun1.1609523b.png";